import React from "react";
import { StyledSignIn } from "./SignIn.styled";
import SignInCard from "./SignInCard";

function SignIn() {

  return (
    <StyledSignIn>
      <SignInCard />
    </StyledSignIn>
  );
}

export default SignIn;
